<nav class="l-nav" role="navigation" [attr.aria-hidden]="(shouldHide$ | async)"
  [ngClass]="{ 'hidden': (shouldHide$ | async) === true }">
  <!-- Favorites -->
  <ul class="menu favorites" *ngIf="favorites?.length">
    <li class="section-title">
      <div class="nav-item-container">
        <p>Favorites</p>
      </div>
      <ul class="favorite-list" cdkDropList (cdkDropListDropped)="handleDrop($event)">
        <li class="favorite-item" *ngFor="let favorite of favorites; let i = index" cdkDrag>
          @if(checkLdFlags(favorite.childGuid)) {
            <div class="nav-item-container">
              <a class="anchor-link" [attr.id]="'favoriteLink' + i"
                [routerLink]="parseUrl(favorite?.siteUrl || favorite?.menuUrl)"
                [queryParams]="parseQueryParams(favorite?.siteUrl || favorite?.menuUrl)"
                [attr.aria-current]="isNavItemActive(favorite?.siteUrl || favorite?.menuUrl, true) ? 'page' : null">
                {{ favorite?.displayText || favorite?.menuName }}
              </a>
              <button class="btn btn-minus" [attr.id]="'favoriteRemoveBtn' + i" (click)="removeFromFavorites(favorite)"
                aria-label="Remove from favorites" title="Remove from favorites" [attr.aria-pressed]="false">
                <img class="icon icon-minus" src="/assets/images/icons/minus.svg" alt="star">
              </button>

              <button class="btn btn-drag" cdkDragHandle tabindex="-1" [attr.id]="'favoriteReorderBtn' + i">
                <img class="icon" src="/assets/images/icons/arrow_up_thick.svg" alt="star">
                <img class="icon" src="/assets/images/icons/arrow_up_thick.svg" alt="star">
              </button>
            </div>
          }
        </li>
      </ul>
    </li>
  </ul>

  <!-- Main Menu -->
  <ul class="menu">
    <ng-container *ngIf="!isLoading; else loadingContent">
      <ng-container *ngFor="let navItem of navItems; let i = index">
        @if(checkLdFlags(navItem.menuData?.childGuid)) {
          <li class="section-title" [ngClass]="{'section-title--clickable': navItem?.menuData?.menuUrl}">
            <div class="nav-item-container">
              <a *ngIf="isExternalLink(navItem?.menuData?.menuUrl) else internalLink" [href]="navItem?.menuData?.menuUrl"
                target="_blank" rel="noreferrer" [attr.id]="'navHeadingLink' + i"
                [attr.aria-current]="isNavItemActive(navItem?.menuData?.menuUrl, false) ? 'page' : null">
                {{ navItem?.menuData?.menuName }}
              </a>
              <ng-template #internalLink>
                <a *ngIf="navItem?.menuData?.menuUrl else headerText" [attr.id]="'navHeadingLink' + i"
                  [routerLink]="parseUrl(navItem?.menuData?.menuUrl)"
                  [queryParams]="parseQueryParams(navItem?.menuData?.menuUrl)"
                  [attr.aria-current]="isNavItemActive(navItem?.menuData?.menuUrl, false) ? 'page' : null">
                  {{ navItem?.menuData?.menuName }}
                </a>
              </ng-template>
              <ng-template #headerText>
                <p [attr.id]="'navHeadingLabel' + i">{{ navItem?.menuData?.menuName }}</p>
              </ng-template>
              <button class="btn btn-favorite" [attr.id]="'navHeadingAddToFavoritesBtn' + i"
                (click)="addToFavorites(navItem?.menuData)" aria-label="Add to favorites" title="Add to favorites"
                [attr.aria-pressed]="false">
                <img class="icon icon-favorite" src="/assets/images/icons/star.svg" alt="star">
              </button>
            </div>
            <ul *ngIf="navItem?.menuChildren?.length">
              <li *ngFor="let navChild of navItem?.menuChildren; let j = index">
                @if(checkLdFlags(navChild.childGuid)) {
                  <div class="nav-item-container">
                    @if(isExternalLink(navChild?.siteUrl)) {
                      <a
                        [href]="navChild?.siteUrl" target="_blank" rel="noreferrer"
                        [attr.id]="'navChildLink' + i + '_' + (j + 1)"
                        [attr.aria-current]="isNavItemActive(navChild?.siteUrl, false) ? 'page' : null"
                      >
                        {{ navChild?.displayText }}
                      </a>
                    } @else {
                      <a
                        [routerLink]="parseUrl(navChild?.siteUrl)"
                        [queryParams]="parseQueryParams(navChild?.siteUrl)"
                        [attr.id]="'navChildLink' + i + '_' + (j + 1)"
                        [attr.aria-current]="isNavItemActive(navChild?.siteUrl, false) ? 'page' : null"
                      >
                        {{ navChild?.displayText }}
                      </a>
                    }
                    <button class="btn btn-favorite" [attr.id]="'navChildAddToFavoritesBtn' + i + '_' + (j + 1)"
                      (click)="addToFavorites(navChild)" aria-label="Add to favorites" title="Add to favorites"
                      [attr.aria-pressed]="false">
                      <img class="icon icon-favorite" src="/assets/images/icons/star.svg" alt="star">
                    </button>
                  </div>
                }
              </li>
            </ul>
          </li>
        }
      </ng-container>
    </ng-container>
  </ul>

  <!-- Loading Content -->
  <ng-template #loadingContent>
    <app-loading-skeleton [skeletonData]="skeletonLoaderData"></app-loading-skeleton>
  </ng-template>

</nav>
